import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { ShowMore } from 'src/components/ShowMore';
import { OverviewImage } from 'src/components/ProgramDetails/Overview/OverviewImage';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import styles from './Overview.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const Overview: React.FC<Props> = ({ program, loading }) => {
	const isMobile = useIsMobile();

	if (!program?.description) {
		return null;
	}

	return (
		<section
			aria-label='overview'
			className={styles.sectionContainer}
			data-testid='program-detail-overview'
			data-title='Overview'
			id='detail-overview'
			tabIndex={-1}
		>
			<Typography className={isMobile ? styles.titleMobile : styles.title} variant='h2'>
				Overview
			</Typography>
			<Skeleton dataLoading={loading} height={156}>
				<OverviewImage program={program} />
				<ShowMore section='overview'>
					<Typography className={styles.description} variant={isMobile ? 'body1' : 'body2'}>
						{program?.description}
					</Typography>
				</ShowMore>
			</Skeleton>
		</section>
	);
};
